<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div style="border-radius: 20px" class="modal-content mx-3 my-auto">
                <div class="container-fluid transit popup-box">
                    <div class="text-center lottie-container">
                        <lottie-player
                            :src="lottie"  background="transparent"  speed="1"  style="width: 50vw; height: 100%;"  loop autoplay >
                        </lottie-player>
                    </div>

                    <div class="text-center modal-text">
                        <h5 v-html="text">Lorem ipsum</h5>
                    </div>

                    <div class="terms-container text-center">
                        <!-- <input type="checkbox" class="mr-2" id="terms-check" value=true v-model="checked"> -->
                        <!-- <div v-if="!checked" class="checkmark mr-2"></div> -->
                        <lottie-player @click="clickCheckbox()" class="mr-2" id="terms-check"
                            src="https://assets7.lottiefiles.com/datafiles/jEgAWaDrrm6qdJx/data.json"  background="transparent"  speed="1"  style="width: 5rem; height: 5rem; float: left;" >
                        </lottie-player>
                        <span @click="emit('open-url', 'https://www.myappfree.com/en/privacy-policy/')" class="terms-text" for="terms-check" v-html="'Accetto i <font color=\'green\'>Termini e Condizioni</font>'"></span>
                    </div>

                    <div class="submit-container pt-2">
                        <div class="login_bar m-auto">
                            <input v-model="input" :placeholder="placeholder" class="login" >
                            <span class="subscribe_button" :class="(checked && input.match('.+@.+[.].+')) ? 'ready2sub' : 'notready2sub'" @click="(checked && input.match('.+@.+[.].+')) ? subscribe() : null">subscribe</span>
                            <span class="subscribing"></span>
                            <span class="thanks" v-html="$locale.newsletter.done"> Thank you. You have been subscribed</span>
                        </div>
                    </div>
                    

                <!-- <div class="row d-flex my-3">
                    <div class="col">
                        <div style="width: 50%;" class="logo mx-auto">
                            <img class="img-fluid logo" src="@/assets/dark-tree.svg" alt="myapptree logo" />
                        </div>
                    </div>
                </div>

                <div class="text-center modal-text">
                    <span data-text="welcomeback" class="localize" v-html="locale.welcomeback">Hey there! <b>Welcome</b> back again :)</span>
                    <br><br>
                    <span data-text="leavereview" v-html="locale.opinion_is_important"><h5>Your opinion is important to us!<br>How much are you enjoying your MyAppFree experience? &nbsp; </h5></span>

                    <Stars v-on:stars-click="starsClick"></Stars>

                </div>

                <div v-if="!isgoodrate" class="md-form animated zoomIn">
                    <textarea id="issueArea" maxlength="100" class="md-textarea form-control" :placeholder="locale.feedback_placeholder" rows="3"></textarea>
                </div>
                <button type="button" :disabled="disabled" v-on:click="rateNow()"
                    class="btn-sm btn btn-downloadapp w-100 p-0 buttonLink mt-3 align-bottom d-block p-2">
                    <span data-text="rate">{{ buttontext }}</span>
                </button> -->
                <div class="row">
                    <div class="col">
                    <div class="d-flex justify-content-between mt-3 mb-2">
                        <a href="#" class="localize" data-text="notnow" v-html="$locale.rating.not_now" data-dismiss="modal">Not now</a>
                        <!-- <a href="#" v-on:click="neverAgain();" class="localize" v-html="$locale.rating.never_again" data-text="neveragain" data-dismiss="modal">Don't ask me again</a> -->
                    </div>
                    </div>
                </div> 

                </div>
                </div>
            </div>
        </div>
</template>
<script>
/* eslint-disable no-console*/
import axios from "axios";
const $ = window.$;

export default {
    data(){
        return{
            input: "",
            checked: false
        }
    },
    props: ['lottie', 'text', 'placeholder', 'type'],
    mounted(){

    },
    methods: {
        emit: function(eventname, param){
            this.$emit(eventname, param)
        },
        subscribe: function(){
            var country = this.$route.params.country;
            var uuid = localStorage.getItem('UUID');
            var token = (this.$route.query.token) ? this.$route.query.token : 0

            var url = "https://us-central1-myapptree-20dac.cloudfunctions.net/subscribeNewsletter";

            axios.get(url+"?token="+token+"&country="+country+"&userid="+uuid+"&contact="+this.input+"&type="+this.type);

            var subscribe_button = document.querySelector(".subscribe_button");
            var subscribing = document.querySelector(".subscribing");
            var thanks = document.querySelector(".thanks");
            var login = document.querySelector(".login");

            subscribing.classList.add("subscribing_active");
            subscribe_button.classList.add("subscribe_button_active");
            setTimeout(function(){
                login.classList.add("login_active");
            }, 1200);
            setTimeout(function(){
                thanks.classList.add("thanks_active");
            }, 1400);

            setTimeout(function(){
                thanks.classList.remove("thanks_active");
                login.classList.remove("login_active");
                subscribing.classList.remove("subscribing_active");
                subscribe_button.classList.remove("subscribe_button_active");
                //TODO hide modal
                $('#newsletterformmodal').modal('hide');
                localStorage.mailNeverAgain = true;
            }, 4000);
        },
        clickCheckbox: function(){
            this.checked = !this.checked
            const player = document.querySelector("lottie-player#terms-check");
            if (this.checked)
                player.play()
            else
                player.stop()
        },
        neverAgain: function() {
            // window.JSInterface.SetSettings('login_count', '0');
            localStorage.mailNeverAgain = true;
            $('#newsletterformmodal').modal('hide');
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /* .transit{
    -webkit-transition: max-height 1s;
  -moz-transition: max-height 1s;
  -ms-transition: max-height 1s;
  -o-transition: max-height 1s;
  transition: max-height 1s;
            } */
    .modal-text{
        color: white;
        /* text-shadow: grey; */
        text-shadow: 0px 0px 40px rgba(0,0,0,0.2);
    }
    .logo{
        max-width: 15vw;
    }

    /* .container {
	width: 300px;
	height: 300px;
	margin: auto;
} */

.login_bar {
	// width: 85%;
    width: 100%;
	height: 50px;
	background: white;
	border-radius: 10px;
	top: 50%;
	position: relative;
  z-index: 1;
	overflow: hidden;
}

.login {
    border: none;
	background: transparent;
	position: absolute;
	height: 100%;
	// width: 190px;
    width: 60%;
	padding-left: 10px;
	text-align: left;
	line-height: 50px;
	vertical-align: middle;
	z-index: 10;
	-webkit-transition: transform 0.2s ease-in-out 0s;
    -moz-transition: transform 0.2s ease-in-out 0s;
    -o-transition: transform 0.2s ease-in-out 0s;
    transition: transform 0.2s ease-in-out 0s;
}

.login_active {
	-webkit-transform: translateX(300px);
    -moz-transform: translateX(300px);
    -ms-transform: translateX(300px);
    -o-transform: translateX(300px);
    transform: translateX(300px);
}

.subscribe_button:hover{
    &.ready2sub{
        background-color: #6AB04C;
    }
    &.notready2sub{
        background-color: lightgray;
    }
    cursor: pointer;
}

.subscribe_button {
    &.ready2sub{
        background-color: #6AB04C;
    }
    &.notready2sub{
        background-color: lightgray;
    }
	position: absolute;
	top: -50px;
    z-index: 4;
    width: 40%;
	/* left: 200px; */
    right: 0;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	height: 150px;
	// width: 100px;
	text-align: center;
	line-height: 150px;
	vertical-align: middle;
	color: white;
	-webkit-transition: transform 0.5s ease 0s;
    -moz-transition: transform 0.5s ease 0s;
    -o-transition: transform 0.5s ease 0s;
    transition: transform 0.5s ease 0s;
}

.subscribe_button_active{
	-webkit-transform: translateY(50px);
    -moz-transform: translateY(50px);
    -ms-transform: translateY(50px);
    -o-transform: translateY(50px);
    transform: translateY(50px);
}

.subscribing{
	background: #7ED6DF;
	height: 100%;
	width: 300px;
	z-index: 5;
	position: absolute;
	left:-300px;
	display: inline-block;
	-webkit-transition: transform 1s ease 0s ;
    -moz-transition: transform 1s ease 0s ;
    -o-transition: transform 1s ease 0s ;
    transition: transform 1s ease 0s ;
}

.subscribing_active {
	-webkit-transform: translateX(300px);
    -moz-transform: translateX(300px);
    -ms-transform: translateX(300px);
    -o-transform: translateX(300px);
    transform: translateX(300px);
}

.thanks{
    color: white;
    text-shadow: 0px 0px 40px rgba(0,0,0,0.2);
	background: transparent;
	height: 100%;
	width: 300px;
	z-index: 5;
	text-align: left;
	line-height: 50px;
	vertical-align: middle;
	padding-left: 10px;
	position: absolute;
	top:50px;
	display: inline-block;
	-webkit-transition: transform 0.5s ease 0s ;
    -moz-transition: transform 0.5s ease 0s ;
    -o-transition: transform 0.5s ease 0s ;
    transition: transform 0.5s ease 0s ;
}

.thanks_active {
	-webkit-transform: translateY(-50px);
    -moz-transform: translateY(-50px);
    -ms-transform: translateY(-50px);
    -o-transform: translateY(-50px);
    transform: translateY(-50px);
}


/* Hide the browser's default checkbox */
/* .terms-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
} */

/* Create a custom checkbox */
/* .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
} */

/* On mouse-over, add a grey background color */
/* .terms-container:hover input ~ .checkmark {
  background-color: #ccc;
} */

/* When the checkbox is checked, add a blue background */
/* .terms-container input:checked ~ .checkmark {
  background-color: #2196F3;
} */

/* Create the checkmark/indicator (hidden when not checked) */
/* .checkmark:after {
  content: "";
  position: absolute;
  display: none;
} */

/* Show the checkmark when checked */
/* .terms-container input:checked ~ .checkmark:after {
  display: block;
} */

/* Style the checkmark/indicator */
/* .terms-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
} */
.terms-text{
    position: relative;
    top:1.8rem;
    right: 2rem;
}

</style>